import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import ViewsTable from '../../../../components/tables/ViewsTable';
import InputField from '../../../../components/inputs/inputField';
import API from '../../../../utils/API';

class AddGroupsModal extends React.Component {
    constructor(props) {
        super(props);
        const columns = {
			name: 'Name'
		};
		const columnTypes = {
			name: 'text'
		};
        const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: true,
				sortDesc: false
			};
		});
        this.state = {
            selectedColumnSort: null,
            sortDesc: false,
            searchTerm: '',
            checkedGroups: {},
            groups: [],
            selectedGroupsCount: 0,
            columns: columns,
			columnTypes: columnTypes,
			normalizedColumns: normalizedColumns,
            selectedColumnSort: null,
			toggledColumns: toggledColumns,
        };
    }
    componentDidMount() {
        const { groups, attendeeGroups } = this.props;
        const filteredGroups = (groups || []).filter((group) => !group.dynamicGroup);

        let checkedGroups = {};
        for (let i = 0; i < attendeeGroups.length; i++) {
            checkedGroups[attendeeGroups[i]._id] = true;
        }

        this.setState({
            groups: filteredGroups.sort((a, b) => a.name.localeCompare(b.name)),
            checkedGroups: checkedGroups,
            selectedGroupsCount: Object.keys(checkedGroups).length
        });

    }

    searchEntries = (searchText) => {
        this.setState({
            searching: searchText != '' ? true : false,
            searchText: searchText ? searchText : '',
        });
    };
    sortData = (column, sortAsc, sortDesc) => {

		const { normalizedColumns } = this.state;

		const updatedColumns = normalizedColumns.map((col) => {
			if (col.key == column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});

		this.setState({
			normalizedColumns: updatedColumns,
			selectedColumnSort: column,
			sortDesc: sortDesc ? true : false
		});
	};

    
    

    renderContent = () => {

        const { selectedColumnSort, searchTerm, toggledColumns, sortDesc,normalizedColumns } = this.state;

        let columns = {};
        let columnTypes = {};
        let checkRow = () => { };
        let checkAllRows = () => { };
        let checkedRows = [];
        let data = [];
        let sortData = () => { };
        columns = {
            name: 'Name'
        };
        columnTypes = {
            name: 'text'
        };
    
        checkRow = (entryId) => {
            const checked = this.state.checkedGroups;
            checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
            this.setState({
                checkedGroups: checked,
                selectedGroupsCount: Object.keys(checked).length
            });
        };
        checkAllRows = (entryIds) => {
            let checked = this.state.checkedGroups;
            entryIds.length > 0
                ? entryIds.forEach((entryId) => {
                    checked[entryId] = true;
                })
                : (checked = {});

            this.setState({
                checkedGroups: checked,
                selectedGroupsCount: Object.keys(checked).length
            });
        };
        checkedRows = this.state.checkedGroups;
        data = this.state.groups;

        if (selectedColumnSort) {
            data = data.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            data = sortDesc ? data.reverse() : data;
        }

        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        return (
            <div>
                <ViewsTable
                    style={{ margin: 0, paddingTop: 0, paddingBottom: 25, height: "calc(100vh - 380px)"   }}
                    columns={normalizedColumns}
                    toggledColumns={toggledColumns}
                    data={data}
                    mainColumnActive={false}
                    checked={checkedRows}
                    checkRow={checkRow}
                    mainActions={[]}
                    checkAllRows={checkAllRows}
                    sortData={this.sortData}
                    title={'Groups'}
                />
                <p style={{ width: 200,  paddingTop: 10  }} className="small gray mb-0 mr-25">
                {Object.keys(checkedRows || {}).length} selected out of {data.length || 0} record
                {data.length === 1 ? "" : "s"}
                </p>
            </div>
        )

    }
    submit = async () => {
        const { attendee, eventId, orgId } = this.props;
        const { checkedGroups } = this.state;


        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/attendees/${attendee._id}`, {
                groups: Object.keys(checkedGroups),
                request: 'updateGroups',
            })
            .then((res) => {
                if (res.data) {
                    this.props.addGroups(Object.keys(checkedGroups));
                    this.props.toggle();
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({
                    invalid: true,
                    submitting: false
                });
            });


    }

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, searchTerm, selectedGroupsCount } = this.state;

        return (
            <div>
                <FieldModal
                    size="large"
                    isOpen={isOpen}
                    modalTitle={"Groups"}
                    bodyHeaderText={'Choose groups to add to this attendee'}
                    bodyDescription={''}
                    overflowHidden={true}
                    bodyContent={() => {
                        return (
                            <div className=''
                            >
                                <div style={{}} className='mb-10 flex'>
                                    <div className='flex aic'>
                                        <InputField
                                            classes="m-0 viewSearch"
                                            placeholder="Search "
                                            clickIcon={true}
                                            required={true}
                                            value={searchTerm}
                                            onChange={(e) => {
                                                clearTimeout(this.searchTimeout);
                                                this.setState({ searchTerm: e.target.value },
                                                    () => {
                                                        this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
                                                    });

                                            }}
                                            prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                            inputIcon={searchTerm != '' &&
                                                <i
                                                    onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
                                                    className="las la-times-circle"
                                                    style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                                />}
                                        />
                                    </div>

                                </div>
                                {this.renderContent()}
                            </div>
                        )
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? (
                        `Add Groups`
                    ) : (
                        'Adding...'
                    )}
                    actionButton={() => { this.submit() }}
                    actionButtonDisabled={submitting}
                    isFullWidthBody={true}


                ></FieldModal>
            </div >

        );
    }
}

export default AddGroupsModal;
